module.exports = __webpack_public_path__ + "static/media/Final.23e9a0cb.svg";